import styled from "styled-components";
import { layout, space, flexbox, background, color } from "styled-system";

export const Hero = styled.div`
  ${layout};
  ${space};
  ${flexbox};
  ${background};
  ${color};
`;
